import { MutableObservableOption, Terminable, Terminator } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { TrackType } from "../../timeline/TrackType";
export class SoundfontDeviceBoxAdapter {
    type = "instrument";
    accepts = "midi";
    #terminator = new Terminator();
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    #loader;
    #soundfont;
    #preset;
    #loaderSubscription = Terminable.Empty;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
        this.#loader = new MutableObservableOption();
        this.#soundfont = new MutableObservableOption();
        this.#preset = new MutableObservableOption();
        this.#terminator.ownAll(this.#loader.subscribe(this.#loaderObserver), this.#box.file.catchupAndSubscribe(({ targetVertex }) => this.#loader.wrapOption(targetVertex.map(({ box }) => context.soundfontManager.getOrCreate(box.address.uuid)))), this.#box.presetIndex.catchupAndSubscribe(owner => this.#soundfont.match({
            none: () => this.#preset.clear(),
            some: soundfont => this.#preset.wrap(soundfont.presets[owner.getValue()] ?? soundfont.presets[0])
        })));
    }
    get loader() { return this.#loader; }
    get soundfont() { return this.#soundfont; }
    get preset() { return this.#preset; }
    get presetIndex() { return this.#box.presetIndex.getValue(); }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get labelField() { return this.#box.label; }
    get iconField() { return this.#box.icon; }
    get defaultTrackType() { return TrackType.Notes; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get acceptsMidiEvents() { return true; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() {
        this.#loaderSubscription.terminate();
        this.#loaderSubscription = Terminable.Empty;
        this.#parametric.terminate();
    }
    #wrapParameters(_box) {
        return {};
    }
    #loaderObserver = (loader) => loader.match({
        none: () => {
            this.#preset.clear();
            this.#soundfont.clear();
        },
        some: loader => loader.soundfont.match({
            none: () => {
                this.#preset.clear();
                this.#soundfont.clear();
                this.#loaderSubscription.terminate();
                this.#loaderSubscription = loader.subscribe(state => {
                    if (state.type === "loaded") {
                        const soundfont = loader.soundfont.unwrap();
                        this.#preset.wrap(soundfont.presets[this.presetIndex] ?? soundfont.presets[0]);
                        this.#soundfont.wrap(soundfont);
                    }
                    else if (state.type === "error") {
                        this.#preset.clear();
                        this.#soundfont.clear();
                    }
                    else if (state.type === "idle") {
                        this.#preset.clear();
                        this.#soundfont.clear();
                    }
                });
            },
            some: soundfont => {
                this.#soundfont.wrap(soundfont);
                this.#preset.wrap(soundfont.presets[this.presetIndex] ?? soundfont.presets[0]);
            }
        })
    });
}
